<template>
  <div class="switch-change-amount">
    <div class="label" @click="$store.commit('setChangeAmountEnabled', !show)">
      <template v-if="!show">
        <p>{{ $t('SwitchChangeAmount.edit_amount') }}</p>
      </template>
      <template v-else>
        <p>{{ $t('SwitchChangeAmount.close_edit_amount') }}</p>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import helpers from '../../mixins/helpers';

export default {
  name: 'SwitchChangeAmount',

  mixins: [helpers],

  computed: {
    ...mapGetters({
      show: 'getChangeAmountEnabled',
    }),
  },
};
</script>
